import { PrimaryHeader } from '@/components/Layout/Header/PrimaryHeader';
import { Container } from '@/components/Layout/Container';
import { AccountSettings } from '@/components/Settings/AccountSettings';
import { PreferenceSettings } from '@/components/Settings/PreferenceSettings';
import { IntegrationSettings } from '@/components/Settings/IntegrationSettings';
import { useAuth } from '@/context/AuthContext';
import { Navigate } from 'react-router-dom';

export function SettingsPage() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <PrimaryHeader />
      <Container>
        <div className="py-8 space-y-8">
          <div>
            <h1 className="text-3xl font-bold">Settings</h1>
            <p className="text-muted-foreground mt-2">
              Manage your account settings and preferences
            </p>
          </div>

          <div className="space-y-6">
            <AccountSettings />
            <PreferenceSettings />
            <IntegrationSettings />
          </div>
        </div>
      </Container>
    </div>
  );
}